// extracted by css-extract-rspack-plugin
export default {"noMobilePressEffects":"noMobilePressEffects-oDCDMn"};